__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['invoice-management-start'].baseUrl;
import ModuleContainer from './components/InvoiceManagementStart';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "7.x"
  });
}